import * as React from 'react';

import { UncontrolledDropdown, DropdownToggle, DropdownMenu, NavItem, NavLink, NavbarBrand } from 'reactstrap';
import { NavLink as Link } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import appConfig from 'app/config/constants';

export const NavDropdown = props => (
  <UncontrolledDropdown nav inNavbar id={props.id}>
    <DropdownToggle nav caret className="nav-link-modern d-flex align-items-center gap-2">
      <FontAwesomeIcon icon={props.icon} />
      <span>{props.name}</span>
    </DropdownToggle>
    <DropdownMenu right className="dropdown-modern" style={props.style}>
      {props.children}
    </DropdownMenu>
  </UncontrolledDropdown>
);

export const BrandIcon = props => (
  <div {...props} className="brand-icon">
    <img src="/static/images/logo-betting-96.png" alt="Logo" />
  </div>
);

// Webpack reads the version from pom.xml, so the header follows every release
const appVersion = (appConfig.VERSION || '').replace('-SNAPSHOT', '');

export const Brand = props => (
  <NavbarBrand tag={Link} to="/dashboard" className="brand-logo-modern">
    <BrandIcon />
    <span className="brand-title-modern">Betting Bookshop</span>
    {appVersion ? <span className="navbar-version">v{appVersion}</span> : null}
  </NavbarBrand>
);

export const Home = props => (
  <NavItem>
    <NavLink tag={Link} to="/dashboard" className="nav-link-modern d-flex align-items-center gap-2">
      <FontAwesomeIcon icon="home" />
      <span>Home</span>
    </NavLink>
  </NavItem>
);
